import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-face-timeline-table',
  templateUrl: './face-timeline-table.component.html',
  styleUrls: ['./face-timeline-table.component.scss'],
})
export class FaceTimelineTableComponent {
  @Input() set incidentTableData(val: IIncidents) {
    let newIncidentLocation;
    let parsedLocation;
    if (this.isJsonString(val.incidentLocation)) {
      parsedLocation = JSON.parse(val.incidentLocation);
      newIncidentLocation = parsedLocation[0]?.label ?? val.incidentLocation;
      const newVal = { ...val, incidentLocation: newIncidentLocation };
      this.temp = newVal;
    } else {
      newIncidentLocation = val.incidentLocation;
      const newVal = { ...val, incidentLocation: newIncidentLocation };
      this.temp = newVal;
    }
    // Parse and modify the incidentLocation
    //parsedLocation = JSON.parse(val.incidentLocation);
    // newIncidentLocation = parsedLocation[0]?.label ?? val.incidentLocation;;
    // const newVal = {...val, incidentLocation: newIncidentLocation };
    // this.temp = newVal;
    // this.temp = val;

    if (val.isANPR) {
      this.dataSource = val.anprTimeline;
      this.tagLineAnpr = 'ANPR detection timeline for ' + val.incidentDescription;
    } else if (val.isFaceMatch) this.dataSource = val.faceTimeline;
    this.mobileCardData = {
      dataSource: this.dataSource,
      incidentLocation: val.incidentLocation,
      sourceAsset: val.sourceAsset,
      incidentName: val.incidentDescription,
    };
  }
  @Input() set isIncidentDetailsClosed(val: boolean) {
    if (!val) {
      this.isShowDetails = false;
      this.expandedDetail = '';
    }
  }

  screenSize: ScreenType;
  filteredDataSource: MatTableDataSource<IIncidents>;
  tagLineAnpr = 'ANPR detection timeline for ';
  rowIndex = 0;
  isShowDetails = false;
  expandedDetail = '';
  displayedColumns: string[] = ['no', 'source', 'location', 'date', 'time'];
  dataSource: Date[];
  temp: IIncidents;
  mobileCardData: any;

  constructor(private screen: AumyeResponsiveScreenService) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ScreenType = ScreenType;
  private isJsonString(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
}
